class MCartAddons extends HTMLElement {
   constructor() {
      super(), this.selectors = {
         zipCode: '[name="address[zip]"]',
         province: '[name="address[province]"]',
         country: '[name="address[country]"]',
         addressForm: '[data-address="root"]',
         shippingMessage: ".m-cart-addon__shipping-rate",
         cartDiscountCode: '[name="discount"]',
         cartDiscountCodeNoti: "[data-discount-noti]",
         cartNote: '[name="note"]',
         saveAddonButton: ".m-cart-addon--save",
         closeAddonButton: ".m-cart-addon--close",
         calcShippingButton: ".m-cart-addon--calculate",
         triggerAddonButton: ".m-cart-addon--trigger-button",
         devliveryTime: '[name="attributes[Delivery time]"]',
         preferredPharmacy: '[name="attributes[_Prefered Pharamcy]"]',
         removeDiscountButton: "[data-ph-discount-remove]"
      }, this.cartWrapper = document.querySelector(".m-cart-drawer"), this.isCartPage = "cart" === MinimogSettings.templateName, this.isCartPage && (this.cartWrapper = document.querySelector(".m-cart__footer--wrapper")), this.initAddress = !1, this.cartOverlay = this.cartWrapper.querySelector(".m-cart__overlay"), this.domNodes = queryDomNodes(this.selectors, this), this.rootUrl = window.Shopify.routes.root, this.discountCodeKey = "minimog-discount-code", this.deliveryCodeKey = "minimog-delivery-code", 
        (this.preferredPharmacyKey = "minimog-preferred-pharmacy"),
        (this.preferredPharmacyKeyCheck = document.querySelector("#preferred-pharmacy-select")),
        this.init()
   }
   init() {
      const {
         cartDiscountCode: e,
         cartDiscountCodeNoti: t,
         devliveryTime: s , 
         preferredPharmacy: p
      } = this.domNodes;
      if (addEventDelegate({
            selector: this.selectors.triggerAddonButton,
            context: this,
            handler: (e, t) => {
               if (e.preventDefault(), this.isCartPage) {
                  const e = document.querySelector(".m-cart-addon__body.open");
                  e && e.classList.remove("open")
               }
               const {
                  open: s
               } = t.dataset, o = this.cartWrapper.querySelector(`#m-addons-${s}`);
               this.removeActiveAllButton(), t.classList.add("active"), o && o.classList.add("open"), this.cartOverlay && this.cartOverlay.classList.add("open"), this.openAddon = o, "shipping" === s && fetchSection("country-options", {
                  url: window.MinimogSettings.base_url
               }).then((e => {
                  const t = e.querySelector("#AddressCountry"),
                     s = t && t.querySelectorAll("option"),
                     i = o.querySelector("#MadrressCountry select");
                  s && s.forEach((e => {
                     i && i.appendChild(e)
                  })), this.setupCountries(), i.value = i && i.dataset.default
               })).catch(console.error)
            }
         }), addEventDelegate({
            selector: this.selectors.closeAddonButton,
            context: this.cartWrapper,
            handler: this.close.bind(this)
         }), addEventDelegate({
            selector: this.selectors.calcShippingButton,
            context: this.cartWrapper,
            handler: this.calcShipping.bind(this)
         }), addEventDelegate({
            event: "click",
            selector: this.selectors.removeDiscountButton,
            context: this.cartWrapper,
            handler: this.removeDiscount.bind(this)
         }), e) {
         const s = localStorage.getItem(this.discountCodeKey);
         s && (e.value = s, t && (t.style.display = "inline"))
      }
      if (s) {
         const e = localStorage.getItem(this.deliveryCodeKey);
         e && (s.value = e)
      }
      this.saveAddonValue();
      this.checkPharmacyValue();
      const o = (new Date).toISOString().slice(0, 16),
         i = this.querySelector("#delivery-time");
      i && (i.min = o)
   }
   removeActiveAllButton() {
      const e = this.querySelectorAll(this.selectors.triggerAddonButton);
      e && e.forEach((e => e.classList.remove("active")))
   }
   setupCountries() {
      this.initAddress || Shopify && Shopify.CountryProvinceSelector && (new Shopify.CountryProvinceSelector("AddressCountry", "AddressProvince", {
         hideElement: "AddressProvinceContainer"
      }), this.initAddress = !0)
   }
   close(e) {
      e.preventDefault(), this.openAddon.classList.remove("open"), this.cartOverlay && this.cartOverlay.classList.remove("open"), this.removeActiveAllButton(), this.openAddon = null
   }
   calcShipping(e) {
      e.preventDefault();
      const t = e.target.closest(".m-cart-addon__action");
      t.classList.add("m-spinner-loading");
      const s = this.domNodes.zipCode && this.domNodes.zipCode.value && this.domNodes.zipCode.value.trim(),
         o = this.domNodes.country.value,
         i = this.domNodes.province.value;
      this.domNodes.shippingMessage.classList.remove("error"), this.domNodes.shippingMessage.innerHTML = "";
      const n = "true" === t.dataset.showDeliveryDays;
      fetch(`${this.rootUrl}cart/shipping_rates.json?shipping_address%5Bzip%5D=${s}&shipping_address%5Bcountry%5D=${o}&shipping_address%5Bprovince%5D=${i}`).then((e => e.json())).then((e => {
         if (e && e.shipping_rates) {
            const {
               shipping_rates: s
            } = e, {
               shippingRatesResult: o,
               noShippingRate: i
            } = MinimogStrings;
            if (s.length > 0) {
               t.classList.remove("m-spinner-loading");
               const e = document.createElement("P");
               e.classList.add("m-cart-addon__shipping-rate--label"), e.innerHTML = `${o.replace("{{count}}",s.length)}:`, this.domNodes.shippingMessage.appendChild(e), s.map((e => {
                  const {
                     deliveryOne: s = "Day",
                     deliveryOther: o = "Days"
                  } = t.dataset;
                  let i = "";
                  if (e.delivery_days.length > 0 && n) {
                     let t = s;
                     const n = e.delivery_days[0],
                        r = e.delivery_days.at(-1);
                     n > 1 && (t = o), i = n === r ? `(${n} ${t})` : `(${n} - ${r} ${t})`
                  }
                  const r = document.createElement("P");
                  r.classList.add("m-cart-addon__shipping-rate--item"), r.innerHTML = `${e.name}: <span>${e.price} ${Shopify.currency.active}</span> ${i}`, this.domNodes.shippingMessage.appendChild(r)
               }))
            } else t.classList.remove("m-spinner-loading"), this.domNodes.shippingMessage.innerHTML = `<p>${i}</p>`
         } else t.classList.remove("m-spinner-loading"), Object.entries(e).map((e => {
            this.domNodes.shippingMessage.classList.add(e[0] && e[0].toLowerCase());
            const t = `${e[1][0]}`,
               s = document.createElement("P");
            s.classList.add("m-cart-addon__shipping-rate--error"), s.innerHTML = `${t}<sup>*</sup>`, this.domNodes.shippingMessage.appendChild(s)
         }))
      })).catch(console.error)
   }
   getNoticeTarget() {
      return this.cartWrapper?.querySelector?.("[data-ph-cart-notice-host]") || this.cartWrapper || document.body;
   }
   async removeDiscount(e) {
      e.preventDefault();
      const button = e.target.closest(this.selectors.removeDiscountButton);
      button && button.classList.add("m-spinner-loading");
      try {
         const response = await fetch(`${this.rootUrl}cart/update.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ discount: "" })
         });
         if (!response.ok) throw new Error("The discount code could not be removed.");
         let cart = await response.json();
         localStorage.removeItem(this.discountCodeKey);
         if (this.domNodes.cartDiscountCode) this.domNodes.cartDiscountCode.value = "";
         if (this.domNodes.cartDiscountCodeNoti) this.domNodes.cartDiscountCodeNoti.style.display = "none";
         if (window.ProhealthAutomaticGifts && typeof window.ProhealthAutomaticGifts.afterDiscountMutation === "function") {
            cart = await window.ProhealthAutomaticGifts.afterDiscountMutation(cart, { clearSuppression: true }) || cart;
         }
         if (window.ProhealthCartUnlockedGifts && typeof window.ProhealthCartUnlockedGifts.afterCartMutation === "function") {
            await window.ProhealthCartUnlockedGifts.afterCartMutation(cart);
         } else if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source: "cart-discount-remove" });
         }
         if (window.ProhealthCartDelivery && typeof window.ProhealthCartDelivery.refreshProgress === "function") {
            await window.ProhealthCartDelivery.refreshProgress();
         }
         this.close(e);
      } catch (error) {
         window.MinimogTheme?.Notification?.show({
            target: this.getNoticeTarget(),
            type: "error",
            message: error.message || "The discount code could not be removed."
         });
      } finally {
         button && button.classList.remove("m-spinner-loading");
      }
   }
   async getCartState() {
      const response = await fetch(`${this.rootUrl}cart.js`, {
         headers: { Accept: "application/json" },
         cache: "no-store"
      });
      if (!response.ok) throw new Error("The cart could not be refreshed.");
      return response.json();
   }
   async updateDiscountCodes(value) {
      const response = await fetch(`${this.rootUrl}cart/update.js`, {
         method: "POST",
         headers: { "Content-Type": "application/json", Accept: "application/json" },
         body: JSON.stringify({ discount: value || "" })
      });
      if (!response.ok) throw new Error("The discount code could not be applied.");
      return response.json();
   }
   applicableDiscountCodes(cart) {
      return (cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : [])
         .filter((discount) => discount && discount.applicable !== false && discount.code)
         .map((discount) => String(discount.code).trim())
         .filter(Boolean);
   }
   discountIsApplicable(cart, code) {
      const target = String(code || "").toLowerCase();
      return (cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : []).some((discount) =>
         discount && String(discount.code || "").toLowerCase() === target && discount.applicable !== false
      );
   }
   showCouponConflictDialog() {
      const settings = window.ProhealthAutomaticGifts && typeof window.ProhealthAutomaticGifts.getSettings === "function"
         ? window.ProhealthAutomaticGifts.getSettings()
         : null;
      const existing = document.querySelector("[data-ph-coupon-conflict]");
      existing && existing.remove();
      const wrapper = document.createElement("div");
      wrapper.className = "ph-coupon-conflict";
      wrapper.setAttribute("data-ph-coupon-conflict", "");
      wrapper.innerHTML = `
         <div class="ph-coupon-conflict__backdrop" data-ph-coupon-choice="gift"></div>
         <div class="ph-coupon-conflict__dialog" role="dialog" aria-modal="true" aria-labelledby="ph-coupon-conflict-title">
            <h2 class="ph-coupon-conflict__title" id="ph-coupon-conflict-title"></h2>
            <p class="ph-coupon-conflict__message"></p>
            <div class="ph-coupon-conflict__actions">
               <button type="button" class="m-button m-button--secondary" data-ph-coupon-choice="gift"></button>
               <button type="button" class="m-button m-button--primary" data-ph-coupon-choice="coupon"></button>
            </div>
         </div>`;
      wrapper.querySelector(".ph-coupon-conflict__title").textContent = settings?.conflictTitle || "Choose your offer";
      wrapper.querySelector(".ph-coupon-conflict__message").textContent = settings?.conflictMessage || "This coupon cannot be combined with the promotional free gift currently in your cart. You can keep the free gift, or continue with the coupon and remove the promotional gift.";
      wrapper.querySelector('[data-ph-coupon-choice="gift"]:not(.ph-coupon-conflict__backdrop)').textContent = settings?.keepGiftLabel || "Keep my free gift";
      wrapper.querySelector('[data-ph-coupon-choice="coupon"]').textContent = settings?.continueCouponLabel || "Use coupon and remove gift";
      document.body.appendChild(wrapper);
      const couponButton = wrapper.querySelector('[data-ph-coupon-choice="coupon"]');
      couponButton && couponButton.focus();
      return new Promise((resolve) => {
         const finish = (choice) => {
            document.removeEventListener("keydown", onKeydown);
            wrapper.remove();
            resolve(choice);
         };
         const onKeydown = (event) => {
            if (event.key === "Escape") finish("gift");
         };
         document.addEventListener("keydown", onKeydown);
         wrapper.addEventListener("click", (event) => {
            const target = event.target.closest("[data-ph-coupon-choice]");
            if (target) finish(target.dataset.phCouponChoice || "gift");
         });
      });
   }
   async refreshCartSystems(cart, source = "cart-discount") {
      if (window.ProhealthCartUnlockedGifts && typeof window.ProhealthCartUnlockedGifts.afterCartMutation === "function") {
         await window.ProhealthCartUnlockedGifts.afterCartMutation(cart);
      } else if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
         window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source });
      }
      if (window.ProhealthCartDelivery && typeof window.ProhealthCartDelivery.refreshProgress === "function") {
         await window.ProhealthCartDelivery.refreshProgress();
      }
   }
   async applyCouponWithPromotionResolution(code) {
      const giftsApi = window.ProhealthAutomaticGifts;
      const originalCart = await this.getCartState();
      const originalCodes = this.applicableDiscountCodes(originalCart);
      const originalDiscountString = originalCodes.join(",");
      const hasPromoGifts = giftsApi && typeof giftsApi.hasPromotionalGifts === "function"
         ? giftsApi.hasPromotionalGifts(originalCart)
         : false;

      let appliedCart = await this.updateDiscountCodes(code);
      if (this.discountIsApplicable(appliedCart, code)) {
         if (giftsApi && typeof giftsApi.clearCouponSuppression === "function") giftsApi.clearCouponSuppression();
         return { cart: appliedCart, code, removedGift: false };
      }

      if (!hasPromoGifts || !giftsApi || typeof giftsApi.removePromotionalGifts !== "function") {
         await this.updateDiscountCodes(originalDiscountString);
         throw new Error("This discount code is not applicable to the current cart.");
      }

      const removed = await giftsApi.removePromotionalGifts(appliedCart);
      const cartWithoutPromoGifts = removed.cart || await this.getCartState();
      const testedCart = await this.updateDiscountCodes(code);

      if (!this.discountIsApplicable(testedCart, code)) {
         await this.updateDiscountCodes(originalDiscountString);
         if (typeof giftsApi.clearCouponSuppression === "function") giftsApi.clearCouponSuppression();
         if (typeof giftsApi.sync === "function") await giftsApi.sync({ cart: await this.getCartState() });
         throw new Error("This discount code is not applicable to the current cart.");
      }

      await this.updateDiscountCodes(originalDiscountString);
      if (typeof giftsApi.clearCouponSuppression === "function") giftsApi.clearCouponSuppression();
      if (typeof giftsApi.sync === "function") await giftsApi.sync({ cart: await this.getCartState() });

      const choice = await this.showCouponConflictDialog();
      if (choice !== "coupon") {
         return { cart: await this.getCartState(), code: originalDiscountString, keptGift: true, cancelled: true };
      }

      const latestWithGift = await this.getCartState();
      await giftsApi.removePromotionalGifts(latestWithGift);
      const finalCart = await this.updateDiscountCodes(code);
      if (!this.discountIsApplicable(finalCart, code)) {
         await this.updateDiscountCodes(originalDiscountString);
         if (typeof giftsApi.clearCouponSuppression === "function") giftsApi.clearCouponSuppression();
         if (typeof giftsApi.sync === "function") await giftsApi.sync({ cart: await this.getCartState() });
         throw new Error("This discount code is no longer applicable to the current cart.");
      }
      if (typeof giftsApi.afterDiscountMutation === "function") {
         await giftsApi.afterDiscountMutation(finalCart, { suppressCode: code });
      } else if (typeof giftsApi.setCouponSuppression === "function") {
         giftsApi.setCouponSuppression(code);
      }
      return { cart: finalCart, code, removedGift: true };
   }

   saveAddonValue() {
      addEventDelegate({
         event: "click",
         context: this.cartWrapper,
         selector: this.selectors.saveAddonButton,
         handler: async (e, t) => {
            e.preventDefault();
            const {
               cartDiscountCode: s,
               cartDiscountCodeNoti: o,
               devliveryTime: i
            } = this.domNodes;
            if ("coupon" === t.dataset.action && s) {
               const code = s.value.trim();
               t.classList.add("m-spinner-loading");
               try {
                  if (!code) throw new Error("Enter a discount code first.");
                  const result = await this.applyCouponWithPromotionResolution(code);
                  if (result.cancelled) {
                     const activeCodes = this.applicableDiscountCodes(result.cart).join(",");
                     activeCodes ? localStorage.setItem(this.discountCodeKey, activeCodes) : localStorage.removeItem(this.discountCodeKey);
                     s.value = activeCodes;
                     o && (o.style.display = activeCodes ? "inline" : "none");
                     await this.refreshCartSystems(result.cart, "cart-discount-gift-kept");
                     this.close(e);
                     return;
                  }
                  const activeCodes = this.applicableDiscountCodes(result.cart).join(",");
                  activeCodes ? localStorage.setItem(this.discountCodeKey, activeCodes) : localStorage.removeItem(this.discountCodeKey);
                  s.value = activeCodes || code;
                  o && (o.style.display = activeCodes ? "inline" : "none");
                  await this.refreshCartSystems(result.cart, "cart-discount");
                  if (result.removedGift && window.MinimogTheme?.Notification?.show) {
                     const settings = window.ProhealthAutomaticGifts?.getSettings?.();
                     window.MinimogTheme.Notification.show({
                        target: this.getNoticeTarget(),
                        type: "success",
                        message: settings?.removedCouponMessage || "Your coupon was applied and the non-combinable promotional free gift was removed."
                     });
                  }
                  this.close(e);
               } catch (error) {
                  window.MinimogTheme?.Notification?.show({
                     target: this.getNoticeTarget(),
                     type: "error",
                     message: error.message || "The discount code could not be applied."
                  });
               } finally {
                  t.classList.remove("m-spinner-loading");
               }
            }
            if ("note" === t.dataset.action && (this.updateCartNote(), this.close(e)), "delivery" === t.dataset.action) {
               const t = i.value;
               Date.parse(t) > Date.now() ? (localStorage.setItem(this.deliveryCodeKey, t), this.close(e)) : (localStorage.setItem(this.deliveryCodeKey, ""), i.value = "", window.MinimogTheme.Notification.show({
                  target: this.querySelector(".m-cart-addon-message-error"),
                  method: "appendChild",
                  type: "error",
                  message: window.MinimogStrings.valideDateTimeDelivery,
                  last: 3e3,
                  sticky: !1
               }))
            }
         }
      })
   }

   checkPharmacyValue() {
      addEventDelegate({
         event: "awesomplete-selectcomplete",
         context: this.cartWrapper,
         selector: this.selectors.preferredPharmacy,
         handler: (e, t) => {
            const selectName = this.selectors.preferredPharmacy;
            const inputElement = document.querySelector(selectName);
            if (!inputElement) {
               console.error('Input element not found');
               return;
            }

            const requestData = JSON.stringify({
               attributes: {
                  "PreferedPharamcyCode": inputElement.dataset.pid,
                  "PreferedPharmacy": inputElement.dataset.pname
               }
            });

            fetch(`${window.MinimogSettings.routes.cart_update_url}`, {
               ...fetchConfig(),
               body: requestData,
            });
         },
      });
   }
  
   updateCartNote() {
      const e = this.domNodes.cartNote.value,
         t = JSON.stringify({
            note: e
         });
      fetch(`${window.MinimogSettings.routes.cart_update_url}`, {
         ...fetchConfig(),
         body: t
      })
   }
}
customElements.define("m-cart-addons", MCartAddons);